import React, { createContext, useContext, useState, useCallback } from 'react';

interface SelectedPeriodContextValue {
  selectedMonth: number | null; // null = no explicit selection yet
  selectedYear: number | null;
  setPeriod: (month: number, year: number) => void;
  setYear: (year: number) => void;
}

const SelectedPeriodContext = createContext<SelectedPeriodContextValue | null>(null);

export const SelectedPeriodProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedMonth, setSelectedMonth] = useState<number | null>(null);
  const [selectedYear, setSelectedYear] = useState<number | null>(null);

  const setPeriod = useCallback((month: number, year: number) => {
    setSelectedMonth(month);
    setSelectedYear(year);
  }, []);

  const setYear = useCallback((year: number) => {
    setSelectedYear(year);
  }, []);

  return (
    <SelectedPeriodContext.Provider value={{ selectedMonth, selectedYear, setPeriod, setYear }}>
      {children}
    </SelectedPeriodContext.Provider>
  );
};

export const useSelectedPeriod = (): SelectedPeriodContextValue => {
  const ctx = useContext(SelectedPeriodContext);
  if (!ctx) {
    throw new Error('useSelectedPeriod must be used within SelectedPeriodProvider');
  }
  return ctx;
};
